export default {
	ERROR_MISSING_NEW_PERIOD: 'Der mangler en medlemskabsperiode for den valgte type. Opret den, og prøv igen'
} as { [key: string]: string };
